import React from 'react';
import BaseTestCard from '../BaseTestCard/BaseTestCard';
import TestSelectionFormFieldNames from '../../../../../../Models/TestSelectionFormFieldNames';
import TestInfo from '../../../../../../../../Models/TestInfo';
import UIStrings from '@/Utils/UIStrings';
import { resourceBaseUrl } from '@/AppSettings';
import { PreviewQuestionsProps } from '../PreviewQuestions/Dialog/usePreviewQuestions';

interface PersonalityTestCardProps extends Omit<PreviewQuestionsProps, 'testType'> {
    test: TestInfo;
}

function PersonalityTestCard({ test, demoQuestions, likertOptions }: PersonalityTestCardProps): React.JSX.Element {
    return (
        <BaseTestCard
            {...test}
            testName={UIStrings.Personality}
            fieldName={TestSelectionFormFieldNames.isPersonalitySelected}
            imageURL={`${resourceBaseUrl}/images/Personality.png`}
            demoQuestions={demoQuestions}
            likertOptions={likertOptions}
        />
    );
}

export default PersonalityTestCard;
